<template>
  <v-row>
    <v-btn text>
      <h1>良いおこない</h1>
    </v-btn>
    <v-btn text>
      <h1>悪いおこない</h1>
    </v-btn>
  </v-row>
</template>

<script>

export default {
  name: "CheckListSwitch",
  data: () => ({
  }),
  methods: {
  },
  components: {
  },
  props: []
};

</script>

<style scoped>
h1 {
  color: #fff;
  margin-bottom: 40px;
}
</style>
